module.exports = __webpack_public_path__ + "static/media/9-2.420e9283.mp3";